var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 13.53C12.1 13.53 12.07 13.53 12.05 13.53C12.02 13.53 11.98 13.53 11.95 13.53C9.68001 13.46 7.98001 11.69 7.98001 9.50998C7.98001 7.28998 9.79001 5.47998 12.01 5.47998C14.23 5.47998 16.04 7.28998 16.04 9.50998C16.03 11.7 14.32 13.46 12.15 13.53C12.13 13.53 12.13 13.53 12.12 13.53ZM12 6.96998C10.6 6.96998 9.47001 8.10998 9.47001 9.49998C9.47001 10.87 10.54 11.98 11.9 12.03C11.93 12.02 12.03 12.02 12.13 12.03C13.47 11.96 14.52 10.86 14.53 9.49998C14.53 8.10998 13.4 6.96998 12 6.96998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.7499C9.30999 22.7499 6.73999 21.7499 4.74999 19.9299C4.56999 19.7699 4.48999 19.5299 4.50999 19.2999C4.63999 18.1099 5.37999 16.9999 6.60999 16.1799C9.58999 14.1999 14.42 14.1999 17.39 16.1799C18.62 17.0099 19.36 18.1099 19.49 19.2999C19.52 19.5399 19.43 19.7699 19.25 19.9299C17.26 21.7499 14.69 22.7499 12 22.7499ZM6.07999 19.0999C7.73999 20.4899 9.82999 21.2499 12 21.2499C14.17 21.2499 16.26 20.4899 17.92 19.0999C17.74 18.4899 17.26 17.8999 16.55 17.4199C14.09 15.7799 9.91999 15.7799 7.43999 17.4199C6.72999 17.8999 6.25999 18.4899 6.07999 19.0999Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.f428ac45371572b9aa5fcf8b36f3ab4e.svg";
export { ForwardRef as ReactComponent };